import { render } from "./LoadingScreen.vue?vue&type=template&id=7b4902b2&scoped=true"
import script from "./LoadingScreen.vue?vue&type=script&lang=js"
export * from "./LoadingScreen.vue?vue&type=script&lang=js"

import "./LoadingScreen.vue?vue&type=style&index=0&id=7b4902b2&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-7b4902b2"

export default script